import courseService from './courseService';

export default courseService;